import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { CurrentProjectContainer, TagBox } from "./style";
import MoreMenu from "../../../../../components/moreMenu";
import * as ProjectAction from "../../../../../actions/project";
import { Confirm } from "../../../../../components/confirm";
import { Modal } from "../../../../../components/modal";
import { Box } from "../projectList/style";
import Form from "../../../../../containers/projectList/form";
import { reduxForm } from "redux-form";
import { isEqual } from "lodash";
import * as ProvinceAction from "../../../../../actions/province";
import { ProjectType } from "../../../../../constants/projectType";
import {
  EXPIRED_PREMIUM,
  FREE,
  NEAR_ENDING_PREMIUM,
  PREMIUM,
  STATE_NAMES
} from "../../../../../constants/premiumState";
import {
  PURCHASE_STEPS_TYPE,
  PURCHASE_TYPE,
  PURCHASE_USED_KEY
} from "../../../../../constants/purchase";
import UserInfo from "../userInfo";

class CurrentProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      showArchiveConfirm: false,
      editProjectName: "",
      editProjectId: "",
      showShareProjectConfirm: false,
      projectArchiveData: "",
      originDeletedProject: ""
    };
  }
  static getDerivedStateFromProps(props, state) {
    let result = {};
    if (
      props.deletedProject !== undefined &&
      !isEqual(props.deletedProject, state.originDeletedProject)
    ) {
      result.deletedProject = props.deletedProject;
      result.originDeletedProject = props.deletedProject;
      window.location.href = "/";
    }
    return result;
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.archiveProjectLoading !== this.props.archiveProjectLoading &&
      !this.props.archiveProjectLoading
    ) {
      this.setState({ showArchiveConfirm: false });
    }
  }
  showMenu(state) {
    this.setState({ menu: state });
  }
  showConfirm(state) {
    this.setState({ confirm: state });
  }
  edit(values) {
    let data = values;
    data.name = values.name;
    data.description = values.description;
    data.state_id = (values.state_id && values.state_id.key) || null;
    data.city_id = (values.city_id && values.city_id.key) || null;
    data.type = values.type.key;
    data.start_date = values.start_date;
    this.props.editProject(data, this.state.editProjectId);
    this.setState({ showModal: false, menu: false });
  }
  modalToggle() {
    const { showModal } = this.state;
    this.props.initialize({
      name: "",
      type: "",
      state_id: "",
      city_id: "",
      start_date: "",
      description: ""
    });
    this.setState({ showModal: !showModal, modalMode: "add" });
  }
  archiveProject(projectId) {
    this.props.archiveProject(projectId, { archive_state: true });
  }
  editProject() {
    const project = JSON.parse(localStorage.getItem("project_info"));
    const { showModal } = this.state;
    let state = null;
    let city = null;
    let type = null;
    let start_date = null;
    let description = null;
    if (project.state !== null) {
      state = {
        key: project.state !== null ? project.state.id : "",
        value: project.state !== null ? project.state.name : ""
      };
      if (project.state) {
        this.props.getCity({
          id: project.state.id,
          name: project.state.name
        });
      }
    }
    if (project.city !== null) {
      city = {
        key: project.city.id,
        value: project.city.name
      };
    }
    if (project.type !== null) {
      type = ProjectType.filter(type => type.key === project.type)[0];
    }
    if (project.start_date !== null) {
      start_date = project.start_date;
    }
    if (project.description !== null) {
      description = project.description;
    }
    this.setState(
      {
        showModal: !showModal,
        editProjectId: project.id,
        editProjectName: project.name
      },
      () => {
        this.props.initialize({
          name: project.name,
          type: type,
          state_id: state,
          city_id: city,
          start_date: start_date,
          description: description,
          currency: project.currency
        });
      }
    );
  }
  setPurchaseParameter(purchaseActionType, step) {
    this.props.history.push({
      pathname: "/purchase",
      state: {
        [PURCHASE_USED_KEY.FORM_STEP]: step,
        [PURCHASE_USED_KEY.PURCHASE_ACTION]: purchaseActionType
      }
    });
  }
  render() {
    const {
      menu,
      showArchiveConfirm,
      projectArchiveData,
      showModal,
      editProjectName,
      showShareProjectConfirm
    } = this.state;
    const { init } = this.props;
    const isGift =
      init.data.project &&
      init.data.project.project_status &&
      init.data.project.project_status.price &&
      init.data.project.project_status.price.is_gift;
    return (
      <CurrentProjectContainer>
        <UserInfo
          userName={this.props.userInfoData}
          wallet={this.props.wallet}
        />
        {showModal && (
          <Modal
            show={showModal}
            closeHandler={() => this.modalToggle()}
            body={
              <Box>
                <Form
                  submitButtonText={"ویرایش پروژه"}
                  onSubmit={this.edit.bind(this)}
                  onCancel={() => this.modalToggle()}
                />
              </Box>
            }
            loading={false}
            header={{
              title: `ویرایش پروژه ${editProjectName}`,
              icon: "icon mapsa-outline-layers",
              iconColor: "primary_vivid"
            }}
          />
        )}
        {showArchiveConfirm && (
          <Confirm
            show={showArchiveConfirm}
            rejectHandler={() => this.setState({ showArchiveConfirm: false })}
            close={() => this.setState({ showArchiveConfirm: false })}
            acceptHandler={() => this.archiveProject(projectArchiveData)}
            content={{
              type: "danger",
              title: "آرشیو پروژه",
              message:
                "با آرشیو پروژه‌ها اطلاعات پروژه شما حذف نخواهد شد و در صورت نیاز می‌توانید آن را از طریق صفحه مدیریت پروژه‌ها مجددا به لیست پروژه‌های فعال خود بازگردانید.",
              acceptButtonText: "آرشیو پروژه",
              rejectButtonText: "انصراف"
            }}
            loading={this.props.archiveProjectLoading}
          />
        )}
        <Confirm
          show={showShareProjectConfirm}
          rejectHandler={() =>
            this.setState({ showShareProjectConfirm: false })
          }
          close={() => this.setState({ showShareProjectConfirm: false })}
          content={{
            type: "warning",
            icon: "icon mapsa-i-letter",
            message:
              "شما مجاز به ویرایش پروژه اشتراکی نیستید. در صورت نیاز با مالک پروژه تماس بگیرید.",
            rejectButtonText: "باشه"
          }}
        />
        {/*<i className="icon mapsa-project current-project-icon" />*/}
        <div className="top-row">
          {menu && (
            <MoreMenu
              close={this.showMenu.bind(this, false)}
              menu={[
                {
                  icon: "mapsa-edit",
                  text: "ویرایش",
                  onClick: () => {
                    this.editProject();
                  }
                },
                {
                  icon: "mapsa-archive-soild",
                  text: "آرشیو پروژه",
                  onClick: () => {
                    this.setState({
                      showArchiveConfirm: true,
                      projectArchiveData: localStorage.getItem("project_id")
                    });
                  }
                }
              ]}
            />
          )}
          <div className="current-project-name">
            <span title={this.props.currentProject}>
              {this.props.currentProject}
            </span>
            <TagBox
              type={
                init.data.project.premium_state === PREMIUM ||
                init.data.project.premium_state === NEAR_ENDING_PREMIUM
                  ? "success"
                  : "secondary"
              }
            >
              {STATE_NAMES[init.data.project.premium_state]}
            </TagBox>
          </div>
          <i
            className="icon mapsa-more current-project-menu-icon"
            onClick={
              this.props.loading
                ? () => false
                : init.data.is_owner
                ? this.showMenu.bind(this, !menu)
                : () =>
                    this.setState({
                      showShareProjectConfirm: true
                    })
            }
            title={
              init.data.is_owner
                ? ""
                : "شما مجاز به ویرایش پروژه اشتراکی نیستید. در صورت نیاز با مالک پروژه تماس بگیرید."
            }
          />
        </div>
        {init.data.is_owner &&
          (init.data.project.premium_state === FREE ||
            init.data.project.premium_state === EXPIRED_PREMIUM ||
            isGift) && (
            <div className="bottom-row">
              <div
                className="link-button"
                onClick={() =>
                  this.setPurchaseParameter(
                    PURCHASE_TYPE.NEW,
                    PURCHASE_STEPS_TYPE.CHOOSE_PLAN
                  )
                }
              >
                {isGift ? "خرید اشتراک حرفه‌ای" : "ارتقاء به اشتراک حرفه‌ای"}
              </div>
            </div>
          )}
        {init.data.is_owner &&
          ((init.data.project.premium_state === PREMIUM ||
            init.data.project.premium_state === NEAR_ENDING_PREMIUM) &&
            !isGift) && (
            <div className="bottom-row">
              <div
                className="link-button"
                onClick={() =>
                  this.setPurchaseParameter(
                    PURCHASE_TYPE.UPGRADE,
                    PURCHASE_STEPS_TYPE.CHOOSE_PLAN_OPTIONS
                  )
                }
              >
                ارتقاء امکانات
              </div>
            </div>
          )}
        {init.data.is_owner &&
          (init.data.project.premium_state === NEAR_ENDING_PREMIUM &&
            !isGift) && (
            <div className="bottom-row">
              <div
                className="link-button"
                onClick={() =>
                  this.setPurchaseParameter(
                    PURCHASE_TYPE.EXTEND,
                    PURCHASE_STEPS_TYPE.CHOOSE_PLAN
                  )
                }
              >
                تمدید اشتراک
              </div>
            </div>
          )}
      </CurrentProjectContainer>
    );
  }
}

const mapStateToProps = store => {
  return {
    init: store.Init.data,
    editedProject:
      store.Project && store.Project.editedProject
        ? store.Project.editedProject
        : {},
    deletedProject:
      store.Project && store.Project.deletedProject
        ? store.Project.deletedProject
        : undefined,
    loading: store.Project.loading,
    archiveProjectLoading: store.Project.archiveProjectLoading
  };
};
const mapDispatchToProps = dispatch => {
  return {
    // deleteProject: id => {
    //   dispatch(ProjectAction.deleteReq(id));
    // },
    archiveProject: (id, data) => {
      dispatch(ProjectAction.archive(id, data));
    },
    editProject: (data, id) => {
      dispatch(ProjectAction.update(data, id));
    },
    getCity: data => {
      dispatch(ProvinceAction.getCity(data));
    }
  };
};

CurrentProject = reduxForm({
  form: "add_project"
})(CurrentProject);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CurrentProject));
